import { GtmEvent } from './GtmEvent'

export const buttonClick = (
  buttonName?: string,
  buttonContext?: string,
): GtmEvent[] => [{ event: 'buttonClick', buttonName, buttonContext }]
